import type { TFunction } from 'i18next';

export interface FolderCounts {
    subFolderCount?: number;
    implantCount: number;
    scannerCount: number;
    policyCount: number;
    fileCount: number;
    linkCount: number;
}

export const folderItemCount = (counts: FolderCounts) =>
    counts.implantCount +
    counts.scannerCount +
    counts.policyCount +
    counts.fileCount +
    counts.linkCount;

const folderCountEntries = (counts: FolderCounts) =>
    (
        [
            { key: 'subFolders', count: counts.subFolderCount ?? 0 },
            { key: 'implants', count: counts.implantCount },
            { key: 'scanners', count: counts.scannerCount },
            { key: 'policies', count: counts.policyCount },
            { key: 'files', count: counts.fileCount },
            { key: 'links', count: counts.linkCount },
        ] as const
    ).filter(({ count }) => count > 0);

export const folderCountsLabel = (
    counts: FolderCounts,
    t: TFunction
): string => {
    const entries = folderCountEntries(counts);
    return entries.length > 0
        ? entries
              .map(({ key, count }) =>
                  t(`folders.overview.counts.${key}`, { count })
              )
              .join(' · ')
        : t('folders.overview.counts.empty');
};
